import { useEffect } from 'react'

import { getFromStorage, removeFromStorage } from 'src/shared/helpers/sessionStorageHelpers'
import { UserActions, useUserDispatch } from 'src/state/userState'

import { crossTabChannel } from '../../syncSession'

const useSyncRequestListener = () => {
    const userDispatch = useUserDispatch()

    useEffect(() => {
        crossTabChannel.onmessage = (e) => {
            const session = getFromStorage('user')

            if (e.data.request === 'logout' && session.hasOwnProperty('accessToken')) {
                removeFromStorage('user')
                userDispatch({ type: UserActions.LOG_OUT })
                return
            }

            if (e.data.request !== 'sync' || !session.hasOwnProperty('accessToken')) {
                return
            }

            crossTabChannel.postMessage({ session, response: 'sync' })
        }
    }, [])
}

export default useSyncRequestListener
